import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import Render from '../../common/Render';
import InviteCreate from './create';
import List from './List';
import { requestDataIfNeeded } from './duck';

class Screen extends React.Component {
  componentDidMount() {
    this.props.requestInvitesDataIfNeeded();
  }

  handleCreateSuccess = () => {
    this.props.requestInvitesDataIfNeeded();
  };

  renderAfterLoading = () => {
    const { t, invites } = this.props;

    return (
      <React.Fragment>
        <div className="u-margin-bottom">
          <div className="u-display-flex u-flex-wrap u-justify-content-between u-align-items-center">
            <h4 className="u-margin-top-micro u-margin-bottom-none">
              {t('admin.title')}
            </h4>
            <InviteCreate onSuccess={this.handleCreateSuccess} />
          </div>
        </div>
        <div className="o-layout o-layout--large u-margin-bottom-huge">
          <div className="o-layout__item u-margin-bottom">
            <div className="u-padding">
              <div className="c-box-primary__box u-display-flex u-justify-content-between u-align-items-center u-padding-none">
                <div className="u-flex-2">
                  <p className="u-text-uppercase u-font-smaller u-weight-normal">
                    {t('admin.userName')}
                  </p>
                </div>
                <div className="u-flex-3">
                  <p className="u-text-uppercase u-font-smaller u-weight-normal">
                    {t('admin.userEmail')}
                  </p>
                </div>
                <div className="u-flex-4">
                  <p className="u-margin-left-micro u-margin-bottom-micro u-text-uppercase u-font-smaller u-weight-normal">
                    {t('admin.userStatus')}
                  </p>
                </div>
                <div className="u-flex-1" />
              </div>
            </div>
            <List invites={invites} />
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    const { isLoading, error } = this.props;

    return (
      <Render
        isLoading={isLoading}
        error={error}
        render={this.renderAfterLoading}
      />
    );
  }
}

const mapDispatchToProps = { requestInvitesDataIfNeeded: requestDataIfNeeded };

const mapStateToProps = ({ invites }) => ({
  isLoading: invites.isLoading,
  error: invites.error,
  invites: invites.data,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(Screen));



// WEBPACK FOOTER //
// ./src/admin/invites/Screen.js